
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/octoberPrizeDraw",
      function () {
        return require("private-next-pages/octoberPrizeDraw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/octoberPrizeDraw"])
      });
    }
  